export const COOKIES_NOTICE_COOKIE_NAME = "cookie-accepted";
export const COOKIES_NOTICE_COOKIE_EXPIRATION = 30;

export const MIXPANEL_COOKIE_NAME = "ah_mp_id";
export const MIXPANEL_COOKIE_EXPIRATION = 365;

export const AH_PLUS_EMAIL_COOKIE_NAME = "ahplus_signup_email";
export const AH_PLUS_EMAIL_COOKIE_EXPIRATION = "30";
